export default __webpack_public_path__ + "037d4cc56f169b77206a1aa5f0b12f61.svg";